<template>
  <div class="containerHome"></div>
</template>

<script>
export default {
  mounted() {
    const domainName = window.location.hostname

    // vava
    if (this.domainNameFlag('vava', domainName)) {
      window.open('https://www.camfan.chat/#/home', '_self')
      return
    }
    // joychat
    if (this.domainNameFlag('joychat', domainName)) {
      window.open('https://www.joyme.chat/#/home', '_self')
      return
    }
    // echo
    if (this.domainNameFlag('echo', domainName)) {
      window.open('https://www.anonripple.com/#/main', '_self')
      return
    }
    // kiko
    if (this.domainNameFlag('kiko', domainName)) {
      window.open('https://www.inpulse.fun/#/home', '_self')
      return
    }
  }
}
</script>
<style lang="scss" scoped>
.containerHome {
  width: 100%;
  height: 100vh;
  background-color: #999;
  padding: 15px 15px;
  .title {
    color: #fff;
    font-size: 20px;
    font-weight: 600;
    margin-bottom: 20px;
  }
  button {
    height: 30px;
    padding: 0 8px;
    margin: 5px;
  }
}
</style>
